import { gql } from "@apollo/client";

const GET_INTELLI_UPLOAD_HISTORY_DETAILS = gql`
  query GetIntelliUploadHistoryDetails($params: IntelliUploadProcessQueueInput!) {
    queueDetails(params: $params) {
      queueId
      processId
      isEmailSent
      isQueueCompleted
      isRuleTriggered
      documents {
        documentId
        purchaserName
        purchaserKey
        fileDisplayName
        fileName
        fileMimeType
        documentTypeId
        documentType
        documentSubtypeId
        documentSubtype
        claimNumber
        checkNumber
      }
    }
  }
`;

export default GET_INTELLI_UPLOAD_HISTORY_DETAILS;